import React, { useState, useEffect, useRef } from 'react';
import Header from './Header';
import './ImageChat.css';
import { FaDownload } from 'react-icons/fa';

const ImageChat = ({ onLogout, token }) => {
    const [message, setMessage] = useState('');
    const [numImages, setNumImages] = useState(3);
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedImages, setSelectedImages] = useState([]);
    const ws = useRef(null);

    useEffect(() => {
        ws.current = new WebSocket('wss://zdwlj2l547.execute-api.us-west-2.amazonaws.com/production');

        ws.current.onopen = () => {
            console.log('WebSocket connection established');
        };

        ws.current.onmessage = (event) => {
            console.log('Message received:', event.data);
            const receivedData = JSON.parse(event.data);
            if (receivedData.image_urls) {
                setImages(receivedData.image_urls);
                setLoading(false);
            }
        };

        ws.current.onclose = () => {
            console.log('WebSocket connection closed');
        };

        return () => {
            if (ws.current) {
                ws.current.close();
            }
        };
    }, []);

    const base64Encode = async (selectedImage) => {
        if (!selectedImage) {
            return "";
        }

        try {
            const response = await fetch(selectedImage);
            const blob = await response.blob();
            const reader = new FileReader();

            return new Promise((resolve, reject) => {
                reader.onloadend = () => {
                    const base64String = reader.result.split(',')[1]; // Get base64 part
                    resolve(base64String);
                };
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        } catch (error) {
            console.error('Error fetching or converting image:', error);
            return "";
        }
    };

    const handleSendMessage = () => {
        if (message.trim()) {
            setNumImages(numImages);
            generateImages();
        }
    };

    const generateImages = async () => {
        setLoading(true);
        setImages(Array(numImages).fill(null)); // Initialize empty containers
        const base64Images = await Promise.all(selectedImages.map(image => base64Encode(image)));
        try {
            const response = await fetch(
                "https://mp6xkfz87j.us-west-2.awsapprunner.com/images",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: token
                    },
                    body: JSON.stringify({
                        prompt: message,
                        image_urls: base64Images,
                        number_of_images: numImages
                    }),
                }
            );

            const data = await response.json();

            if (ws.current && ws.current.readyState === WebSocket.OPEN) {
                ws.current.send(JSON.stringify({ action: 'message', data }));
            }
        } catch (error) {
            console.error("Error sending message:", error);
            setLoading(false);
        }
    };


    const handleDownload = async (src) => {
        const response = await fetch(src);
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'image.png'; // you can set a more specific name
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    };

    const handleSelectImage = (src) => {
        if (selectedImages.includes(src)) {
            setSelectedImages(selectedImages.filter(image => image !== src));
        } else {
            setSelectedImages([...selectedImages, src]);
        }
    };


    return (
        <div>
            <div className="chat-container">
                <Header onLogout={onLogout} token={token} />
                <div className="input-row">
                    <textarea
                        rows="3"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        onKeyDown={(e) => {
                            if ((e.ctrlKey || e.metaKey) && e.key === 'Enter') {
                                e.preventDefault();
                                handleSendMessage();
                            }
                        }}
                        placeholder="Type your message..."
                        disabled={loading}
                    />
                    <button onClick={handleSendMessage} disabled={loading}>
                        {loading ? 'Generating...' : 'Send'}
                    </button>
                </div>
                <div className="controls">
                    <label>
                        Number of Images:
                        <input
                            type="number"
                            value={numImages}
                            onChange={(e) => setNumImages(Number(e.target.value))}
                            min="1"
                            max="5"
                            disabled={loading}
                        />
                    </label>
                </div>
                <div className="image-display">
                    {images.map((src, index) => (
                        <div key={index} className="image-container">
                            {src ? (
                                <div className="image-wrapper">
                                    <a href={src} target="_blank" rel="noopener noreferrer">
                                        <img src={src} alt={`Generated ${index}`} />
                                    </a>
                                    <div className="icons">
                                        <FaDownload className="download-icon" onClick={() => handleDownload(src)} />
                                        <input
                                            type="checkbox"
                                            name="selected-images"
                                            checked={selectedImages.includes(src)}
                                            onChange={() => handleSelectImage(src)}
                                            className="select-checkbox"
                                        />
                                    </div>
                                </div>
                            ) : (
                                <div className="loading-spinner"></div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ImageChat;
